// extracted by mini-css-extract-plugin
export default {"phraseBlock":"ParaphraseOption_phraseBlock__X9lYX","deletePhraseButton":"ParaphraseOption_deletePhraseButton__nhc1r"};